import "./page-animated.scss";

document.addEventListener('DOMContentLoaded', () => {
  const scene = document.getElementById('scene');
  new Parallax(scene);

  AOS.init();
})